import { Client } from '@core/Client';
import { IntroPrompt } from '@core/GUI/Dialogs/IntroPrompt';
import { MenuDialog } from '@core/GUI/Dialogs/MenuDialog';
import { LockScreen } from '@core/GUI/LockScreen';
import { HelpScreen } from '@core/GUI/Pages/HelpScreen';
import { IMAXAServerMessage } from '@core/Logic/Links/IMAXA/IMAXAProtocol';
import { Constants } from '@core/Utils/Constants';
import { CrazyMegaEpicScalingStructure } from '@core/Utils/HelperFunction'

export class MainScene extends Phaser.Scene {

	/*static Width and Heights are Width and Height that switch along with phone/camera rotation, making the bottom of your phone always height and sides always width
	  as if it was always in landscape mode, this is used whenever we calculate sizes/ratios to have the same image in portrait mode when rotation happens.*/
	public portraitMode: boolean = false;
	public staticHeight: number = window.innerHeight;
	public staticWidth: number = window.innerWidth;
	public helpScreen: HelpScreen;
	public menuDialog: MenuDialog;
	public introPrompt: IntroPrompt;

	public lockScreen: LockScreen;

	public slotExitButton: Phaser.GameObjects.Image;//gets toggled visible by helpScreen

	protected backgroundImage: Phaser.GameObjects.Image;
	protected firstConnect:boolean = true;

	// Be careful when changing the key to dynamic assignmnent 
	// Wrong assignment here will not load the MainScene from LoadGame scene
	constructor() {
		super({
			key: "MainScene"
		});

		document.body.style.backgroundColor = Constants.MAIN_SCENE.CSS_BACKGROUND_COLOR;
	}

	create(): void {
		Client.remote.OnQuestion = this.OnQuestion.bind(this);//handle server questions

		Client.game.events.addListener(Constants.EVENTS.MODULE_RELOAD, () => { this.ModulesUpdated() });
		this.game.events.on(Constants.EVENTS.AUTO_RESOLVE, () => { this.AutoResolve() });
	}

	protected createCommonChildren(): void {
		this.backgroundImage = this.add.image(0, 0, Constants.SPRITESHEET_GAME_BACKGROUND)
		this.backgroundImage.setOrigin(0)
		this.backgroundImage.setDepth(-10);
		this.children.sendToBack(this.backgroundImage);

		this.lockScreen = new LockScreen(this);
		this.children.add(this.lockScreen);
	}

	update(time: number, delta: number): void {

	}

	public ProcessSettings() {
	}

	protected OnQuestion(question: IMAXAServerMessage) { };

	protected ModulesUpdated() { };

	protected AutoResolve() { };//try to automatically resolve all player required inputs
	/*
	 * Camera and canvas sizes are always height/width of the screen no matter the mode to fill the entire screen,
	 * all of the things inside of the canvas however switch width and height around when rotated (using staticHeight/staticWidth)
	 * to always keep the same ratio and positions eaven in portrait mode
	*/
	resize(scaling: CrazyMegaEpicScalingStructure): void {
		if (!this.game.device.os.desktop) {
			let body = document.getElementById("body")
			if (!body)
				return

			if (document.activeElement && document.activeElement.tagName !== "BODY") {
				body.style.overflowY = "auto";
				return;
			} else {
				body.style.overflowY = "hidden";
			}
		}

		try {
			switch (window.orientation) {
				case 0:
				case 180://portrait -> switch width and height, we are always landscape view on mobile
					this.staticHeight = scaling.width;
					this.staticWidth = scaling.height;
					this.portraitMode = true;
					break;
				case -90:
				case 90:
				default: //landscape
					this.staticHeight = scaling.height;
					this.staticWidth = scaling.width;
					this.portraitMode = false;
					break;
			}
		}
		catch {
			this.staticHeight = scaling.height;
			this.staticWidth = scaling.width;
			this.portraitMode = false;
		}

		this.scale.zoom = scaling.zoom;
		// manually resize the game with the Phaser 3.16 scalemanager
		this.scale.resize(scaling.width, scaling.height);
		// Scale the camera
		this.cameras.main.setViewport(0, 0, scaling.width, scaling.height);
		this.cameras.resize(scaling.width, scaling.height) // this resizes everything

		if (this.portraitMode) {

			this.cameras.cameras[0].setOrigin(0, 0);
			this.cameras.cameras[0].setRotation(Phaser.Math.DegToRad(90));
		}
		else {
			this.cameras.cameras[0].setRotation(0);
		}

		if (this.backgroundImage) {
			this.backgroundImage.setDisplaySize(this.staticWidth, this.staticHeight)
			if (this.portraitMode)
				this.backgroundImage.y = -this.staticHeight;
			else
				this.backgroundImage.y = 0;
		}

		if (this.lockScreen)
			this.lockScreen.OnResize(this.staticWidth, this.staticHeight, this.portraitMode);

		if (this.helpScreen)
			this.helpScreen.Resize(this.staticWidth, this.staticHeight, this.portraitMode);

		if (this.introPrompt) {
			this.introPrompt.resize(this.staticWidth, this.staticHeight, this.portraitMode);
			if (this.portraitMode)
				this.introPrompt.setPosition(0, -this.staticHeight);
			else
				this.introPrompt.setPosition(0, 0);
		}
	}
}
